/* MindStrips Midnight PDP — scroll story + reveals + chart draw */
(function(){
  if(!window.gsap){return;}
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  gsap.registerPlugin(ScrollTrigger);
  if(window.Lenis){var l=new Lenis({lerp:.11});l.on('scroll',ScrollTrigger.update);gsap.ticker.add(function(t){l.raf(t*1000);});gsap.ticker.lagSmoothing(0);}
    /* reveals */
  if(!RM){ gsap.utils.toArray('.mn .reveal').forEach(function(el){ gsap.fromTo(el,{opacity:0,y:30},{opacity:1,y:0,duration:.8,ease:'power2.out',scrollTrigger:{trigger:el,start:'top 88%'}}); }); }
  else { document.querySelectorAll('.mn .reveal').forEach(function(el){el.style.opacity=1;el.style.transform='none';}); }
  /* absorption chart draw */
  if(!RM){ document.querySelectorAll('.mn .daychart path').forEach(function(p){ if(!p.getTotalLength)return; var len=p.getTotalLength(); p.style.strokeDasharray=len; p.style.strokeDashoffset=len; gsap.to(p,{strokeDashoffset:0,ease:'none',scrollTrigger:{trigger:'.daychart',start:'top 80%',end:'bottom 62%',scrub:.5}}); }); }
  /* scroll story */
  var story=document.getElementById('story');
  if(story && !RM){
    var blks=['#blk0','#blk1','#blk2'].map(function(s){return document.querySelector(s);});
    var cur=-1; function setBeat(b){ if(b===cur)return; cur=b; blks.forEach(function(el,i){ if(el) el.classList.toggle('on', i===b); }); }
    setBeat(0);
    var tl=gsap.timeline({scrollTrigger:{trigger:'#story',start:'top top',end:'bottom bottom',scrub:.6,pin:'.storypin',
      onUpdate:function(self){ var p=self.progress; setBeat(p<0.30?0:(p<0.62?1:2)); }}});
    tl.fromTo('#sstrip',{scale:.62,rotate:-10,opacity:0},{scale:1,rotate:0,opacity:1,duration:1,ease:'power2.out'},0)
      .to('#sstrip',{scale:.9,x:20,duration:1},1.5)
      .fromTo('#ca1',{opacity:0,y:16,scale:.9},{opacity:1,y:0,scale:1,duration:.45},1.7)
      .fromTo('#ca2',{opacity:0,y:16,scale:.9},{opacity:1,y:0,scale:1,duration:.45},1.85)
      .fromTo('#ca3',{opacity:0,y:16,scale:.9},{opacity:1,y:0,scale:1,duration:.45},2.0)
      .fromTo('#ca4',{opacity:0,y:16,scale:.9},{opacity:1,y:0,scale:1,duration:.45},2.15)
      .to(['#ca1','#ca2','#ca3','#ca4'],{opacity:0,y:-14,duration:.4},2.7)
      .to('#sstrip',{opacity:0,scale:1.1,duration:.55},2.8)
      .fromTo('#stongue',{opacity:0,scale:.82},{opacity:1,scale:1,duration:.9,ease:'power2.out'},3.15)
      .to('#stongue',{scale:1.04,duration:.8},4.0);
  } else if(story){ document.querySelectorAll('.s-copy .blk').forEach(function(b){b.classList.add('on');}); }
})();
